module.exports = __webpack_public_path__ + "img/img39s.bc87a080.png";